export enum BasketStatus {
  Active = 'ACTIVE',
}
